import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { RespostaConhecimentoTransporte } from "app/types/pesquisa-orcamento/consultas/ConhecimentoTransporte";
import globalMU from "globalMU";
import React from "react";

const estilosTabelas = require('../../../estilos/tabelas.module.scss').default

export type ConchecimentoTrasporteProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    conhecimentosTransporte: RespostaConhecimentoTransporte[]
};

export const ConchecimentoTrasporte = (props: ConchecimentoTrasporteProps) => {
    const cabecalho =
        <div className="_my-2">
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Filial</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.Filial}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nº Orçamento</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.NumeroPedido}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CLiente</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.RazaoSocialCliente}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Vendedor</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.Vendedor}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data</label>
                <p className="_mb-0 _p-2">{globalMU.formatDate(props.orcamentoSelecionado.DataPedido)}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Valor</label>
                <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(props.orcamentoSelecionado.ValorPedido, 2, true)}</p>
            </div>
        </div>

    const tabela =
        <div className="_my-4">
            <table className={`_table _w-full _border-collapse ${estilosTabelas.tabela}`}>
                <thead>
                    <tr>
                        <th>Conhecimento Transporte</th>
                        <th>Filial Conhecimento</th>
                        <th>Carga</th>
                        <th>Filial Carga</th>
                        <th >Transportadora</th>
                    </tr>
                </thead>

                <tbody>
                    {props.conhecimentosTransporte?.map((conhecimentoTransporte) => {
                        return (
                            <tr className="_cursor-pointer hover:_bg-white">
                                <td className="_bg-[#b9b9b9]">{conhecimentoTransporte.Codigo}</td>
                                <td className="_bg-[#b9b9b9]">{conhecimentoTransporte.CodigoFilial + '-' + conhecimentoTransporte.NomeFilial}</td>
                                <td className="_bg-[#b9b9b9]">{conhecimentoTransporte.Carga}</td>
                                <td className="_bg-[#b9b9b9]">{conhecimentoTransporte.CodigoFilialItemFaturado + '-' + conhecimentoTransporte.NomeFilialItemFaturado}</td>
                                <td>{conhecimentoTransporte.CodigoTransportadora + '-' + conhecimentoTransporte.Transportadora}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>

    return (
        <>
            {cabecalho}

            {tabela}
        </>
    )

}